import CircleIcon from '@mui/icons-material/Circle';
import IncompleteCircle from '@mui/icons-material/TonalityOutlined';
import EmptyCircle from '@mui/icons-material/RadioButtonUnchecked';

const ClaimStatusIcon = ({ claim }) => {
  const style = {
    fontSize: '1.2rem',
  };
  switch (claim?.status) {
    case 'pending':
      return <IncompleteCircle color="warning" style={style} />;
    case 'PAID':
      return <CircleIcon color="success" style={style} />;
    case 'PATIENT_PAID':
      return <CircleIcon color="success" style={style} />;
    case 'READY_TO_UPLOAD':
      return <EmptyCircle color="secondary" style={style} />;
    case 'RECEIVED':
      return <EmptyCircle color="secondary" style={style} />;
    case 'NOTE_UPLOADED':
      return <IncompleteCircle color="primary" style={style} />;
    case 'SUBMISSION_COMPLETED':
      return <IncompleteCircle color="primary" style={style} />;
    case 'CANCELED':
      return <EmptyCircle color="disabled" style={style} />;
    case 'REJECTED':
      return <IncompleteCircle color="error" style={style} />;
    case 'DENIED':
      return <IncompleteCircle color="error" style={style} />;
    case 'UPLOAD_ERROR':
      return <EmptyCircle color="error" style={style} />;
    case 'RECEIVED_ERROR':
      return <EmptyCircle color="error" style={style} />;
    case 'NOTE_UPLOAD_ERROR':
      return <EmptyCircle color="error" style={style} />;
    case 'SUBMISSION_COMPLETED_ERROR':
      return <EmptyCircle color="error" style={style} />;
    default:
      return <EmptyCircle color="disabled" style={style} />;
  }
};

export default ClaimStatusIcon;